import React from 'react';
import {
  Control,
  Controller, FieldPath,
  RegisterOptions,
} from 'react-hook-form';

import type { OptionType } from 'common/components/Select/types';
import { IServerItemOption } from 'common/types/fields';
import type { ChangeHandlerType } from 'common/components/FormHF/types';
import Select, { ISelectProps } from 'common/components/Select';
import { ICustomOptionProps } from 'common/components/FieldGenerator/types';
import { FallbackFormValues } from 'utils/type-tools';

interface ISelectHFProps<TFormValue extends FallbackFormValues> extends Omit<ISelectProps, 'value' |'name'> {
  name: FieldPath<TFormValue>,
  control: Control<TFormValue>,
  rules?: RegisterOptions,
  onChangeHandler?: ChangeHandlerType<TFormValue>,
  renderOptionLabelComponent?: () => React.FC<ICustomOptionProps> | undefined,
}

const SelectHF = <TFormValue extends FallbackFormValues = {}>({
  name,
  label,
  control,
  rules,
  onChangeHandler,
  ...props
}: ISelectHFProps<TFormValue>) => (
  <Controller
    name={name}
    control={control}
    rules={{ ...rules }}
    render={({
      field,
      fieldState: { error },
    }) => (
      <Select
        {...props}
        name={name}
        label={label}
        value={field.value as IServerItemOption} // TODO fix type
        onChange={(newValue: OptionType | null) => {
          if (onChangeHandler) {
            onChangeHandler((newValue ?? undefined) as TFormValue[keyof TFormValue]);
          }
          field.onChange(newValue);
        }}
        required={!!rules?.required}
        error={error?.message}
      />
    )}
  />
  );

// @ts-ignore
export default SelectHF;
